import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=6e6c2ffa&scoped=true&"
import script from "./NotificationMenu.vue?vue&type=script&lang=ts&"
export * from "./NotificationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=6e6c2ffa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c2ffa",
  null
  
)

export default component.exports